// Route search params, kept apart from the page (2026-10-31): the route file's validateSearch is not code-split, so
// whatever it imports ships in the first-load entry chunk. This file must stay free of React, UI and messages.
export const MEMBER_TABS = ["schedule", "time-off", "one-on-ones", "access", "profile", "onboarding"] as const;
export type MemberTab = (typeof MEMBER_TABS)[number];
export type MemberSearch = { tab?: MemberTab };
